"use client";

import StepperProgressBar from "@homeinstead/ui/components/StepperProgressBar";

type StepperDisplayConfig = {
  variant?: "classic" | "progress" | null;
  duration?: number | null;
};

/**
 * Adapter between a Sanity `stepperDisplay` config and the `StepperProgressBar`
 * UI primitive.
 *
 * Returns null for the default "classic" variant so callers can drop this
 * component in unconditionally — it only renders when the "progress" variant
 * is configured.
 *
 * Future step types (regular steps, hero mode) reuse this adapter; they simply
 * need to pass their `stepperDisplay` field and the current progress context.
 */
function LeadFormStepperDisplay({
  stepperDisplay,
  currentStep,
  totalSteps,
  className,
}: {
  stepperDisplay: StepperDisplayConfig | null | undefined;
  currentStep: number;
  totalSteps: number;
  className?: string;
}) {
  if (stepperDisplay?.variant !== "progress") {
    return null;
  }

  const durationMs = stepperDisplay.duration ?? 5000;

  return (
    <StepperProgressBar
      className={className}
      currentStep={currentStep}
      durationMs={durationMs}
      totalSteps={totalSteps}
    />
  );
}

export { LeadFormStepperDisplay };
